<template>
  <p>
    <template v-for="line in splitContent(data.content)">
      <template v-if="line.segments">
        <template v-for="(segment, i) in line.segments">
          {{ getSpaceIfNeeded(segment, i) }}
          <FormattedContent :data="segment">{{
            $dt(segment.content)
          }}</FormattedContent>
        </template>
      </template>
      <template v-else>
        <FormattedContent :data="data">{{ $dt(line) }}</FormattedContent>
      </template>
      <br />
    </template>
  </p>
</template>
<script>
import dynamicLocalization from "../../../mixins/dynamic-localization";
import FormattedContent from "./FormattedContent.vue";

const $dt = function (obj, locale) {
  const fallbackLocale = "de";

  if (obj === void 0) {
    return "?";
  }

  return obj[locale] || obj[fallbackLocale];
};

export default {
  components: { FormattedContent },
  mixins: [dynamicLocalization],
  props: ["data"],
  methods: {
    splitContent(content) {
      return Array.isArray(content) ? content : [content];
    },
    getSpaceIfNeeded(segment, index) {
      const followUpSegment = index > 0;
      const segmentContent =
        segment.content[this.$i18n.locale] || segment.content["de"];
      const spaceNeeded = segmentContent.slice(0, 1).match(/[^\.,!?;]/);

      if (followUpSegment && spaceNeeded) {
        return " ";
      }

      return;
    },
  },
};
</script>
